import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/Order/bus-order'
import _ from 'lodash'


export var order_service = new Vue({
    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async GetAllOrder() {
            await axios.get(this.full_url + 'search/order_index')
                .then(function (response) {
                    bus.GetAllOrder(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllOrderSearch(data) {
            var is_missing = {}
            if (data.missing === true) {
                is_missing = {missing: data.missing}
            }
            await axios({
                method: 'POST',
                url: this.full_url + 'search/order_index/' + data.search,
                data: is_missing
            })
                .then(function (response) {
                    bus.GetAllOrderSearch(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllOrderPaginationSearch(data) {
            var is_missing = {
                from: data.page,
                size: 10
            }
            if (data.is_missing) {
                is_missing.missing = data.missing
            }
            await axios({
                method: 'POST',
                url: this.full_url + 'search/order_index/' + data.search,
                data: is_missing
            })
                .then(function (response) {
                    bus.GetAllOrderSearch(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllOrderPagination(page) {
            let data = {
                from: page.page,
                size: 10
            }
            if (page.missing === true) {
                data = {
                    from: page.page,
                    size: 10,
                    missing: page.missing
                }
            }
            await axios({
                method: 'POST',
                url: this.full_url + 'search/order_index/',
                data: data
            })
                .then(function (response) {
                    bus.GetAllOrderPagination(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllOrderPagination2(page) {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/order_index/',
                data: {
                    from: page,
                    size: 10
                }
            })
                .then(function (response) {
                    bus.GetAllOrderPagination2(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllOrderUpdate() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/order_index/',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    bus.GetAllOrderUpdate(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllProduct() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/product_index/',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    //console.log(response)
                    bus.GetAllProduct(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllProductSku(descount_id) {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/catalogo_index/',
                data: {
                    from: 0,
                    size: 10000,
                    discounts_id: descount_id
                }
            })
                .then(function (response) {
                    bus.GetAllProductSku(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllRestaurant() {
            await axios.get(this.full_url + 'restaurant')
                .then(function (response) {

                    bus.GetAllRestaurant(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllUsers() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/user_index/',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    bus.GetAllUser(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllOrderStatus() {
            await axios.get(this.full_url + 'orderstatus')
                .then(function (response) {
                    bus.GetAllOrderStatus(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllOrderStatusBy(data) {
            console.log(data)
            await axios({
                method: 'POST',
                url: this.full_url + 'order/orderBy/status',
                data: data
            }).then(function (response) {
                bus.GetAllOrderStatusBy(response.data)
            })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllComprasDate(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/buyorder',
                data: data
            })
                .then(function (response) {
                    bus.GetAllComprasDate(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAuditOrders(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'audit/bydate',
                data: data
            })
                .then(function (response) {
                    bus.GetAuditOrders(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetUsersByType(id) {
            await axios({
                method: 'GET',
                url: this.full_url + 'users/getuserBytype/' + id
            })
                .then(function (response) {
                    bus.GetUsersByType(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllSCIDateV1(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/oldencabezado',
                data: data
            })
                .then(function (response) {
                    bus.GetAllSCIDate(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllSCIDate(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/encabezado',
                data: data
            })
                .then(function (response) {
                    bus.GetAllSCIDate(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async CreateOrder(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order',
                data: data
            })
                .then(function (response) {

                    bus.ResponseCreateOrder(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })

        },
        async GetSkuOrder(order_id) {
            await axios({
                method: 'GET',
                url: this.full_url + 'order/orderprodctByorder/'+order_id
            })
                .then(function (response) {

                    bus.GetSkuOrder(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })

        },
        async UpdateOrderStatus(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'order/adminupdate',
                data: data
            })
                .then(function (response) {

                    bus.ResponseUpdateOrderStatus(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })

        },
        async UpdateOrderNew(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'order/update',
                data: data
            })
                .then(function (response) {

                    bus.ResponseUpdateOrderNew(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })

        },
        async OrderStatusMAsivo(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/updatastatus',
                data: data
            })
                .then(function (response) {
                    bus.OrderStatusMAsivo(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetLogOrder(order_id) {
            await axios({
                method: 'GET',
                url: this.full_url + 'order/log/' + order_id
            })
                .then(function (response) {
                    bus.GetLogOrder(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        //ShowDetailOrder(order) {
        //    bus.ShowDetailOrder(order)
        //},
        async GetSku(sku) {
            await axios({
                method: 'GET',
                url: this.full_url + 'productsku/sku/' + sku
            })
                .then(function (response) {
                    return response.data
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        parsearr(arr) {
            return JSON.parse(arr)
        },
    },

    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    }
})
